export const CommonButtonState = {
  InsufficientBalance: "InsufficientBalance",
  WalletNotConnected: "WalletNotConnected",
  WrongNetwork: "WrongNetwork",
};
